"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoLocation = void 0;
var olProj = require("ol/proj");
var Geolocation_1 = require("ol/Geolocation");
var ol_1 = require("ol");
var Style_1 = require("ol/style/Style");
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var Point_1 = require("ol/geom/Point");
var Fill_1 = require("ol/style/Fill");
var Circle_1 = require("ol/style/Circle");
var Stroke_1 = require("ol/style/Stroke");
var olExtent = require("ol/extent");
var GeoLocation = /** @class */ (function () {
    function GeoLocation(_map, _logger, _textPack, options, _elementId, 
    /*
     Element id in which to centre a popup alert message
     */
    _elementIdForMessage) {
        var _this = this;
        if (options === void 0) { options = null; }
        if (_elementId === void 0) { _elementId = "placeholder-geoLocation"; }
        if (_elementIdForMessage === void 0) { _elementIdForMessage = "mapContainer"; }
        this._map = _map;
        this._logger = _logger;
        this._textPack = _textPack;
        this._elementId = _elementId;
        this._elementIdForMessage = _elementIdForMessage;
        this._initialised = false;
        this.init = function (options) {
            if (!_this._initialised) {
                _this._element = $("#" + _this._elementId);
                _this._messageElement = $("#" + _this._elementIdForMessage);
                _this.initOptions(options);
                _this._geoLocation = new Geolocation_1.default(_this._options);
                _this.initHtml();
                _this.initPositionFeature();
                _this.addHandlers();
                _this._initialised = true;
            }
        };
        this.initOptions = function (options) {
            //maximumAge: 20000 = 20 secONDS
            //timeout: 10000 = 10 seconds
            var defaultOptions = {
                tracking: false,
                projection: _this._map.options.displayProjection,
                trackingOptions: {
                    enableHighAccuracy: true,
                    maximumAge: 20000,
                    timeout: 10000
                }
            };
            //merge any passed in options into the default
            _this._options = __assign(__assign({}, defaultOptions), options);
        };
        this.initHtml = function () {
            var html = "\n<div class=\"ol-control\">\t\n\t<button id=\"btnGeoLocateMe\" type=\"button\" title=\"" + _this._textPack.locateMe + "\" aria-label=\"" + _this._textPack.locateMe + "\">\n\t\t<i class=\"fal fa-location\"></i>\n\t</button>        \n</div>\n";
            _this._element.append(html);
        };
        this.initPositionFeature = function () {
            _this._positionFeature = new ol_1.Feature();
            _this._positionFeature.setStyle(new Style_1.default({
                image: new Circle_1.default({
                    radius: 6,
                    fill: new Fill_1.default({
                        color: '#2D87B5'
                    }),
                    stroke: new Stroke_1.default({
                        color: 'rgba(255, 255, 255, 0.4)',
                        width: 45,
                    })
                })
            }));
            _this._vectorLayer = new Vector_1.default({
                map: _this._map.olMap,
                source: new Vector_2.default()
            });
        };
        this.addHandlers = function () {
            $("#btnGeoLocateMe").on("click", _this.onLocateMe);
            _this._geoLocation.on('change', _this.onGeoLocationChange);
            _this._geoLocation.on('change:position', _this.onGeoLocationChangePosition);
            _this._geoLocation.on('error', _this.onGeoLocationError);
        };
        this.onLocateMe = function (e) {
            var self = _this;
            var callBack = function callback(coords, postitionFeature, error) {
                if (coords && !error) {
                    if (self._map.options.extent && !olExtent.containsXY(self._map.options.extent, coords[0], coords[1])) {
                        //Locate me is outside of map bounds
                        var ele_1 = $("<span style=\"z-index:999;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);\" onclick=\"this.remove()\" id=\"btnGeoLocateMe_OutsideMapExtent\" class=\"alert alert-info\">" + self._textPack.locateMeIsOutsideMapExtent + " &nbsp;&nbsp;&nbsp;&nbsp;<button type=\"button\" class=\"btn-close\"></button></span>");
                        self._messageElement.append(ele_1);
                        setTimeout(function () {
                            ele_1.remove();
                        }, 4000);
                    }
                    else {
                        //carry on
                        self._map.olMap.getView().animate({ center: coords, zoom: 15 });
                        if (self._vectorLayer.getSource().getFeatures().length > 0) {
                            //always try to remove feature first
                            self._vectorLayer.getSource().removeFeature(self._positionFeature);
                        }
                        //addfeature and remove after 15 seconds
                        self._vectorLayer.getSource().addFeature(self._positionFeature);
                        window.setTimeout(function () {
                            if (self._vectorLayer.getSource().getFeatures().length > 0) {
                                self._vectorLayer.getSource().removeFeature(self._positionFeature);
                            }
                        }, 15000);
                    }
                }
            };
            self.getCurrentPosition(callBack);
        };
        this.onGeoLocationChange = function (e) {
            _this._logger.log("GeoLocation change: Accuracy=" + _this._geoLocation.getAccuracy() + ", Position=" + _this._geoLocation.getPosition());
        };
        this.onGeoLocationChangePosition = function (e) {
            _this._logger.log("GeoLocation change: Accuracy=" + _this._geoLocation.getAccuracy() + ", Position=" + _this._geoLocation.getPosition());
        };
        this.onGeoLocationError = function (error) {
            _this._logger.error("GeoLocation error: " + error.mesage);
        };
        this.getCurrentPosition = function (callback) {
            var self = _this;
            var onSuccess = function (position) {
                var coords = olProj.fromLonLat([position.coords.longitude, position.coords.latitude], self._map.getDisplayProjection());
                self._logger.log("GeoLocation getCurrentPosition: Accuracy=" + position.coords.accuracy + ", Position=" + coords);
                self._positionFeature.setGeometry(coords ? new Point_1.default(coords) : null);
                callback(coords, self._positionFeature);
            };
            var onError = function (error) {
                self._logger.error("GeoLocation error: code=" + error.code + ", message=" + error.message);
                callback(null, null, error);
            };
            navigator.geolocation.getCurrentPosition(onSuccess, onError, self._options.trackingOptions);
        };
        this.moveMapTocurrentLocation = function (animate, callback) {
            var self = _this;
            var getLocationCallback = function (coords, postitionFeature, error) {
                if (coords && !error) {
                    var animateCallback = function (completed) {
                        //map locate finished let calling function know                   
                        callback();
                    };
                    if (animate) {
                        self._map.olMap.getView().animate({ center: coords, zoom: 15 }, animateCallback);
                    }
                    else {
                        self._map.olMap.getView().fit(new Point_1.default(coords), { maxZoom: 15, nearest: true, callback: animateCallback });
                    }
                }
            };
            self.getCurrentPosition(getLocationCallback);
        };
        this.init(options);
    }
    return GeoLocation;
}());
exports.GeoLocation = GeoLocation;
//# sourceMappingURL=geolocation.js.map